import { Inject, Injectable } from '@angular/core';
import { TranslateService, Translation, TranslationObject } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';
import { StorageService } from './storage.service';
import { SettingsService } from './settings.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { finalize, skip } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LanguageService {
  defaultLang: string;
  queryParamLang:null|string = null;

  constructor(
    private storageService: StorageService,
    private translateService: TranslateService,
    private settings: SettingsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,

    @Inject('environment')
    private environment: {[key: string]: string}


  ) 
  { }

  onAppInit() {
    return new Promise<void>((resolve , reject) => {

      this.defaultLang = this.settings.get('app.defaultLanguage') ?? 'en';
      const savedLang = this.storageService.loadSessionStorage('language');

      
      this.translateService.setFallbackLang(this.defaultLang);

      let languageToUse = this.defaultLang;

      if (this.queryParamLang) {
        languageToUse = this.queryParamLang;
      }
      else if (savedLang) {
        languageToUse = savedLang;
      }

      this.translateService.setFallbackLang(languageToUse);
      // get overridden language
      let endpoint = this.settings.getEndpoint();

      this.http.get(`${endpoint}/Content/json/translation-${languageToUse}`)
      .pipe(
        finalize(() => {
          // * This will always run when observable finishes the stream
          this.translateService.use(languageToUse).subscribe((value) => {
            resolve();
          });
         })  
      )
      .subscribe({
        next: (res) =>{
          console.log('TRANSLATION ', typeof res, res);
          let translationObject = res as Translation;
          if (res) {            
            console.log('should set translation override for ', languageToUse, translationObject);
            
            this.translateService.setTranslation(languageToUse, translationObject, true);
            this.translateService.use(languageToUse);

          }
          else {
            //console.info('Translate override not found for ', languageToUse);
            
          }},
        error: (e) => {
          console.error('ERROR: Translate override not found or json is malformed ', languageToUse);
        },
      });
     
      
      let skipLangRedirect = false;
      if (document.location.pathname.includes("paymentsuccess") || document.location.pathname.includes("paymentcancel")) {
        // do not redirect if we are on payment success or cancel page
        skipLangRedirect = true;
      }

      if (!skipLangRedirect) {
        this.activatedRoute.queryParamMap.subscribe((res:any) => {
          let params =  res.getAll();
          
          let l = res.get('lang')?.toLowerCase();

          // viva payments redirects using fi-fi etc.
          if (l == ('fi-fi')) { l = 'fi'; }
          if (l == ('en-us')) { l = 'en'; }
          if (l == ('sv-se')) { l = 'sv'; }
          if (l == ('de-de')) { l = 'de'; }
          if (l == ('et-ee')) { l = 'et'; }

          if (l) {
            
            if (res.get('hotelCode')) {
              // indicates that this is a deeplink, do not redirect
              this.storageService.saveSessionStorage('language', l);
              this.translateService.setDefaultLang(l);
              this.translateService.use(l);
            }
            else {
              delete params?.lang;
              this.storageService.saveSessionStorage('language', l);
              this.router.navigate(
                [], 
                {
                  relativeTo: this.activatedRoute,
                  queryParams: params,
                  queryParamsHandling: 'replace'
                }
              );
              setTimeout(() => {window.location.reload();}, 300);
            }
            
          }
        
        });
      }
      

    })

    
  }

  onAppInitGiftCard() {
    return new Promise<void>((resolve , reject) => {

      this.defaultLang = this.settings.get('app.defaultLanguage') ?? 'en';
      const savedLang = this.storageService.loadSessionStorage('language');

      
      this.translateService.setDefaultLang(this.defaultLang);

      let languageToUse = this.defaultLang;

      if (this.queryParamLang) {
        languageToUse = this.queryParamLang;
      }
      else if (savedLang) {
        languageToUse = savedLang;
      }

      this.translateService.setDefaultLang(languageToUse);
      // get overridden language
      let endpoint = this.settings.getEndpoint();

      this.http.get(`${endpoint}/Content/json/translation-${languageToUse}`)
      .pipe(
        finalize(() => {
          // * This will always run when observable finishes the stream
          this.translateService.use(languageToUse).subscribe((value) => {
            resolve();
          });
         })  
      )
      .subscribe({
        next: (res) =>{
          if (res) {            
            let translationObject = res as Translation;

            this.translateService.setTranslation(languageToUse, translationObject, true);
            this.translateService.use(languageToUse);
          }
          else {
            //console.info('Translate override not found for ', languageToUse);
            
          }},
        error: (e) => {
          console.error('ERROR: Translate override not found or json is malformed ', languageToUse);
        },
      });
     
      
      let skipLangRedirect = false;
      if (document.location.pathname.includes("paymentsuccess") || document.location.pathname.includes("paymentcancel")) {
        // do not redirect if we are on payment success or cancel page
        skipLangRedirect = true;
      }

      if (!skipLangRedirect) {
        this.activatedRoute.queryParamMap.subscribe((res:any) => {
          let params =  res.getAll();
          
          let l = res.get('lang')?.toLowerCase();

          // viva payments redirects using fi-fi etc.
          if (l == ('fi-fi')) { l = 'fi'; }
          if (l == ('en-us')) { l = 'en'; }
          if (l == ('sv-se')) { l = 'sv'; }
          if (l == ('de-de')) { l = 'de'; }
          if (l == ('et-ee')) { l = 'et'; }

          if (l) {
            
            if (res.get('hotelCode')) {
              // indicates that this is a deeplink, do not redirect
              this.storageService.saveSessionStorage('language', l);
              this.translateService.setDefaultLang(l);
              this.translateService.use(l);
            }
            else {
              delete params?.lang;
              this.storageService.saveSessionStorage('language', l);
              this.router.navigate(
                [], 
                {
                  relativeTo: this.activatedRoute,
                  queryParams: params,
                  queryParamsHandling: 'replace'
                }
              );
              setTimeout(() => {window.location.reload();}, 300);
            }
            
          }
        
        });
      }
      

    })

    
  }

  onAppInitForCustomerSearchMask(languageToUse:string) {
    //runs in app.component in customer searchmask, because translations are loaded statically there

    // get overridden language
    let endpoint = this.settings.getEndpoint();
    this.http.get(`${endpoint}/Content/json/translation-${languageToUse}`)
      .subscribe({
        next: (res) =>{
          console.log('TRANSLATION in customer searchmask ', typeof res, res);
          let translationObject = res as Translation;
          if (res) {            
            console.log('should set translation override for ', languageToUse, translationObject);
            
            this.translateService.setTranslation(languageToUse, translationObject, true);
            this.translateService.use(languageToUse);

          }
          else {
            //console.info('Translate override not found for ', languageToUse);
            
          }},
        error: (e) => {
          console.error('ERROR: Translate override not found or json is malformed ', languageToUse);
        },
      });
  }


  changeLang(lang: string) {
    this.storageService.saveSessionStorage('language', lang);
    this.translateService.use(lang);
    // to fetch the data with the new language we need to reload the window.
    window.location.reload();
  }

  getCurrentLanguage() {
    return this.translateService.currentLang;
  }
}